import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import dayjs from "../../utils/dayjs";

const formatDate = (value: any): string => {
  if (value == null || value === "") return "";
  const d = dayjs.utc(value);
  return d.isValid() ? d.format("MM/DD/YY") : String(value);
};

const dateColumnFormatter = (value: any) => formatDate(value);

export const ManufacturerStockContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "manufacturer_stock",
        transformId: "manufacturer_stock",
        folder: "outputs",
        title: "Inventory at Manufacturers",
        noteText:
          "Finished goods held at manufacturing and vendor sites, which sit outside the planning network. 'Reserved for transfer' is already counted as incoming supply. 'Not on a transfer' is stock nobody has routed yet — it should be zero, and anything here is not counted as supply anywhere.",
        dateHierarchyColumnFilter: null,
        // Every dimension is selectable — location is only the default grain, so keeping
        // it in the dropdown is what allows sku totals across all sites. sku_name is a
        // label riding along with sku rather than a grain, so it is the one exclusion.
        excludedSegmentationsFilter: ["sku_name"],
        measureColumnFilter: null,
        // Filter-by is built from the raw schema; every column here is displayed, so
        // nothing needs excluding. The intended filters are location, or SKU when
        // chasing a specific item.
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        columnHeaderMap: {
          location: "Location",
          sku: "SKU",
          sku_name: "SKU name",
          item_status: "Status",
          item_category: "Category",
          item_sub_category: "Subcategory",
          item_classification: "Classification",
          on_hand: "On hand",
          committed: "Reserved for transfer",
          // The number the view exists for: built, paid for, and routed nowhere.
          available: "Not on a transfer",
          last_receipt_date: "Last received",
          // At location grain this is the longest wait across that site's items, so a
          // single stale item still surfaces instead of being averaged away.
          days_since_last_receipt: "Days since received",
        },
        columnFormatters: {
          last_receipt_date: dateColumnFormatter,
        },
        paramsToTransformArgs,
        tableType: "flat",
      }}
      defaultConfig={defaultConfig}
    />
  );
};
